import { Component, HostListener, Input, OnInit } from '@angular/core';
import { AnchorModel, SetElementiTimeline } from 'src/app/shared/models/node';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sample-timeline',
  templateUrl: './sample-timeline.component.html',
  styleUrls: ['./sample-timeline.component.scss']
})
export class SampleTimelineComponent implements OnInit {

  @Input() block: SetElementiTimeline[] = [];
  @Input() column: string = '';
  public classColumnBoxMarker: string = '';
  public classColumnText: string = '';
  public newDate: string[] = [];
  public objDate: any;
  public domainWebsite = environment.urlApi;
  public itemsAnchor: AnchorModel[] = [];
  @HostListener('click', ['$event'])
  onClick(event: any) {
    this.helperService.viewportScroll(event);
  }

  constructor(public helperService: HelpersService) { }

  ngOnInit(): void {
    this.setColumnItem();
    this.chargeAnchorItems(this.block);
  }

  private setColumnItem() {
    switch (this.column) {
      case '1':
        this.classColumnBoxMarker = 'col-2 pe-3';
        this.classColumnText = 'col-10';
        break;
      default:
        this.classColumnBoxMarker = 'col-1';
        this.classColumnText = 'col-11';
        break;
    }
  }

  public splitDate(date: string): string[] {    
    if (date.includes('-')) {
      this.newDate = date.split('-');
    }
    if (date.includes(' ')) {
      this.newDate = date.split(' ');
    }
    if (this.newDate.length > 1) {
      this.objDate = {
        giorno: this.newDate[0] ? this.newDate[0] : '',
        mese: this.newDate[1] ? this.newDate[1] : '',
        anno: this.newDate[2] ? this.newDate[2] : '',
      }
    } else {
      this.newDate = date.split('/');
      if (this.newDate.length > 1) {
        this.objDate = {
          giorno: this.newDate[0] ? this.newDate[0] : '',
          mese: this.newDate[1] ? this.newDate[1] : '',
          anno: this.newDate[2] ? this.newDate[2] : '',
        }
      }
    }
    return this.newDate;
  }

  private chargeAnchorItems(blockItems: SetElementiTimeline[]) {
    let label: string = '';
    blockItems.forEach((el, idx) => {
      if (this.splitDate(el.data_timeline).length === 1) {
        label = this.newDate[0];
      } else {
        label = this.objDate.giorno + ' ' + this.objDate.mese + ' ' + this.objDate.anno;
      }
      label = this.decodeHtmlCharCodes(label);
      this.itemsAnchor.push({
        idRow: 'timeline-' + idx,
        labelRow: label,
        position: idx
      })
    })
  }

  private decodeHtmlCharCodes = (str: string) =>
    str.replace(/(&#(\d+);)/g, (match, capture, charCode) =>
      String.fromCharCode(charCode)
    );

  // public splitDate(date: string) {
  //   this.newDate = date.split('-');
  //   if (this.newDate.length > 1) {
  //     this.objDate = new Date(this.newDate[2], this.newDate[1], this.newDate[0])
  //   } else {
  //     this.newDate = date.split('/');
  //     if (this.newDate.length > 1) {
  //       this.objDate = new Date(this.newDate[2], this.newDate[1], this.newDate[0])
  //     }
  //   }
  //   return this.newDate;
  // }

}
